import { proxy } from 'valtio'

export const david_store = proxy({
  rangeHigh: 0 as number,
  rangeLow: 0 as number,
  close: 0 as number,
})
